// extracted by mini-css-extract-plugin
export default {"Order":"Order_Order__8uE8T"};